<template>
  <Layout is-demo>
    <div class="">
      <h1 class="text-h4">Printed Licenses</h1>
      <v-divider class="my-2"></v-divider>
    </div>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
        Printed Licenses
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
          <v-data-table 
            :headers="headers"
            :items="tableData"
            sort-by="postDate,credit,debit"
            class="elevation-1"
            :loading="tableLoading"
            loading-text="Loading... Please wait"
            fixed-header
            height="350px"
            :search="search"
             group-by="lOB"
            :no-data-text="tableNoDataText"
            show-group-by
          >
            <template v-slot:item.actions="{ item }">
              <v-btn 
                class="mx-1"
                outlined
                color="teal"
                download
                @click="generatePdf(item)"
              >
                Download PDF
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar" right>
      {{ snackbartext }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </Layout>
</template>

<script>
import Layout from '@/nfmp_components/layouts/MainPortalLayout'
import httpServ from '../services/HTTPService'

export default {
  components: {
    Layout
  },
  data() {
    return {
      search: '',
      memberData:{},
      currentLOBDetails:{},
      prePostData:{},
      pageData:{},
      tableLoading: true,
      singleSelect: true,
      tableNoDataText: 'Thus table has no record!',

      snackbar: false,
      snackbartext: '',
      detailsDialog: false,
      dialog: false,
      dialogMessage: '',
      dialogTitle: '',
      tableItem: [],
      currentItem:[],
      overlay: false,

      headers: [
        { text: 'Certificate #.', value: 'certificate_number' },
        { text: 'Company', value: 'company_name' },
        { text: 'Line Of Business', value: 'lOB' },
        { text: 'Dis. Cat.', value: 'distributor_category' },
        { text: 'State', value: 'operational_state' },
        { text: 'Attribute', value: 'ranking' },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      tableData: []
    }
  },
  created() {
    this.userData = httpServ.getSessionJson('userData')
    this.getTableData()
  },
  mounted() {
  },
  methods: {
    getTableData: function () {
      const url = httpServ.getCertificateUrl('/admin/getPrintedLicenses')
      const resp = httpServ.postFetchWithToken(
        url,
        this.prePostData,
        httpServ.getPaymentApiToken()
      )

      resp.then((result) => {
        if (result.status === 200) {
          this.tableData = result.data
        } 
      })
      this.tableLoading = false
    },
    generatePdf(item) {
      const url = httpServ.getCertificateUrl('/pdf/generateCert')
      const postData = this.prePostData

      const first40Chars = item.company_name.slice(0, 40) 
      const name = first40Chars.replaceAll(' ','-')

      postData.id = item.id
      postData.membership_id = item.membership_id
      postData.state = item.operational_state
      postData.lOB = item.lOB
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(postData)
      })
        .then((response) => response.blob()) // Get the response as a Blob
        .then((blob) => {
          const pdfUrl = URL.createObjectURL(blob) // Create a URL for the Blob

          window.open(pdfUrl, '_blank') // Open the PDF in a new tab
        })
        .catch((error) => {
          console.error('Error generating PDF:', error)
        })
    },
    rowStatus: function(item) {
      if (item.certificate_status === 'Unapproved') {
        return true
      }  else {
        return false
      }
    }
  }
}
</script>

<style scoped>
</style>
